export const ManagerTypes = [
  { key: 'Account Manager', value: 'Account Manager' },
  { key: 'Client Manager', value: 'Client Manager' },
  { key: 'Broker', value: 'Broker' },
  { key: 'Consultant', value: 'Consultant' },
];
